import React, { FC } from 'react';

interface IComponentProps {
  isOverdue?: boolean;
}

export const TrackStoreOrderStatus: FC<IComponentProps> = ({ isOverdue = false }) => {
  return (
    <div className="track-store-order-status" style={{ background: isOverdue ? '#ffd1d1' : '#dbf3e5' }}>
      <div className="mr-2">
        <div className="track-store-order-status-indicator" style={{ background: isOverdue ? '#ff4e4e' : '#5dca8b' }} />
      </div>
      <span className="ff-regular fs-xxxs">{isOverdue ? 'Overdue' : 'On Time'}</span>
    </div>
  );
};
